import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DescriptionIcon from "@mui/icons-material/Description";
import SidebarButton from "../sidebarButton/SidebarButton";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../store/reducerSlices/userSlice";
import { adminLogout } from "../store/reducerSlices/adminSlice";
import { setOpenMobileSidebar } from "../store/reducerSlices/hamburgerSlice";

// toast
import { toast } from "react-toastify";

import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";

// const Sidebar = ({ isCollapsed, openMobileSideBar, setOpenMobileSidebar }) => {
const Sidebar = () => {
  // const broadcastChannel = new BroadcastChannel('user-data-channel');

  const location = useLocation();
  const [activeButton, setActiveButton] = useState("Dashboard");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutButtonRef = useRef(null);

  var user = useSelector((state) => state.user.user);
  var admin = useSelector((state) => state.admin.admin);
  var loggedInData = null;

  if (user) {
    loggedInData = user;
  } else if (admin) {
    loggedInData = admin;
  }

  const { role } = loggedInData;

  const { isSidebarCollapsed, openMobileSideBar } = useSelector(
    (state) => state.hamburger
  );
  // console.log('isSidebarCollapsed', isSidebarCollapsed)
  // console.log('openMobileSideBar', openMobileSideBar)

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setActiveButton("Dashboard");
        break;
      case "/dashboard":
        setActiveButton("Dashboard");
        break;

      case "/profile":
        setActiveButton("Profile");
        break;
      case "/profile/account":
        setActiveButton("Profile");
        break;
      case "/profile/coursedetail":
        setActiveButton("Profile");
        break;
      case "/certificates":
        setActiveButton("Certificates");
        break;
      case "/logbook":
        setActiveButton("Log Books");
        break;
      case "/logbook/samplelogbook":
        setActiveButton("Log Books");
        break;

      case "/performanceappraisal":
        setActiveButton("Performance Appraisal");
        break;
      case "/abstract":
        setActiveButton("Abstract");
        break;
      case "/markingguideline":
        setActiveButton("Marking Guideline");
        break;
      default:
        // setActiveButton('Profile');

        break;
    }
  }, [location.pathname]);
  // const triggerLogout = () => {
  //     if (logoutButtonRef.current) {
  //         logoutButtonRef.current.click();
  //     }
  // };

  // useEffect(() => {
  //     const handleStorageChange = (e) => {
  //         console.log('evet', e);

  //         if (e.key === 'logout' && e.newValue === 'true') {
  //             performLogout();
  //         }
  //     };

  //     window.addEventListener('storage', handleStorageChange);

  //     // return () => {
  //     //     window.removeEventListener('storage', handleStorageChange);
  //     // };
  // }, []);

  const handleLogout = () => {
    localStorage.setItem("logout", "true");
    performLogout();
  };
  const performLogout = () => {
    try {
      dispatch(userLogout());
      dispatch(adminLogout());
      localStorage.removeItem("user");
      localStorage.removeItem("admin");
      localStorage.removeItem("logout");
      const pathname = window.location.pathname;
      pathname.includes("admin")
        ? navigate("/admin/login")
        : navigate("/student/login");
      toast.success("Logged Out Successfully");
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout Failed");
    }
  };
  // const handleLogout = () => {
  //     try {
  //         // Dispatch logout actions
  //         dispatch(userLogout());
  //         dispatch(adminLogout());

  //         // triggerLogout();

  //         // Broadcast logout event to other tabs
  //         // broadcastChannel.postMessage({ type: 'LOGOUT' });

  //         // Navigate to the login page
  //         navigate('/student/login');

  //         // Display success notification
  //         toast.success('Logged Out Successfully');
  //     } catch (error) {
  //         console.error('Logout error:', error);
  //         toast.error('Logout Failed');
  //     }
  // };

  // const handleStorageChange = (e) => {

  //     console.log('event of logout', e)

  //     if (e.key === 'user') {
  //         localStorage.removeItem('user')
  //         navigate('/student/login')
  //     }
  // }

  // window.addEventListener('storage', handleStorageChange)

  const DashboardIcon = ({ isActive, openMobileSideBar }) => {
    return (
      <svg
        width="15"
        height="35"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.0902 0.658647L44.3365 20.9049C45.7537 22.3221 44.7504 24.7449 42.746 24.7449H40.4964V38.2424C40.4964 40.0323 39.7854 41.7489 38.5198 43.0145C37.2541 44.2801 35.5376 44.9912 33.7477 44.9912H31.4981V29.2441C31.4982 27.5227 30.8405 25.8663 29.6595 24.6139C28.4786 23.3614 26.8637 22.6076 25.1453 22.5066L24.7493 22.4953H20.2502C18.4603 22.4953 16.7437 23.2064 15.4781 24.472C14.2125 25.7376 13.5014 27.4542 13.5014 29.2441V44.9912H11.2518C9.46197 44.9912 7.7454 44.2801 6.47976 43.0145C5.21413 41.7489 4.5031 40.0323 4.5031 38.2424V24.7449H2.25352C0.251386 24.7449 -0.754178 22.3221 0.66306 20.9049L20.9093 0.658647C21.3312 0.236915 21.9033 0 22.4998 0C23.0963 0 23.6684 0.236915 24.0902 0.658647ZM24.7493 26.9945C25.346 26.9945 25.9182 27.2315 26.34 27.6534C26.7619 28.0753 26.9989 28.6475 26.9989 29.2441V44.9912H18.0006V29.2441C18.0007 28.6931 18.203 28.1613 18.5691 27.7495C18.9352 27.3378 19.4398 27.0747 19.987 27.0103L20.2502 26.9945H24.7493Z"
          fill={
            isActive && openMobileSideBar
              ? "#2b5972"
              : openMobileSideBar
              ? "#ffffff"
              : isActive
              ? "#2b5972"
              : "#84909A"
          }
        />
      </svg>
    );
  };
  const ProfileIcon = ({ isActive, openMobileSideBar }) => (
    <svg
      width="16"
      height="35"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg "
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10C12.5 7.34784 13.5536 4.8043 15.4289 2.92893C17.3043 1.05357 19.8478 0 22.5 0C25.1522 0 27.6957 1.05357 29.5711 2.92893C31.4464 4.8043 32.5 7.34784 32.5 10C32.5 12.6522 31.4464 15.1957 29.5711 17.0711C27.6957 18.9464 25.1522 20 22.5 20C19.8478 20 17.3043 18.9464 15.4289 17.0711C13.5536 15.1957 12.5 12.6522 12.5 10ZM12.5 25C9.18479 25 6.00537 26.317 3.66117 28.6612C1.31696 31.0054 0 34.1848 0 37.5C0 39.4891 0.790177 41.3968 2.1967 42.8033C3.60322 44.2098 5.51088 45 7.5 45H37.5C39.4891 45 41.3968 44.2098 42.8033 42.8033C44.2098 41.3968 45 39.4891 45 37.5C45 34.1848 43.683 31.0054 41.3388 28.6612C38.9946 26.317 35.8152 25 32.5 25H12.5Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
    </svg>
  );
  const CertificateIcon = ({ isActive, openMobileSideBar }) => {
    return (
      <svg
        width="16"
        height="35"
        viewBox="0 0 45 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg "
      >
        <path
          d="M5.625 0C4.13316 0 2.70242 0.592632 1.64752 1.64752C0.592632 2.70242 0 4.13316 0 5.625V15.9497C2.10984 13.339 5.17037 11.6733 8.50831 11.3191C11.8463 10.9649 15.1882 11.9513 17.7989 14.0611C20.4096 16.1709 22.0753 19.2315 22.4295 22.5694C22.7837 25.9074 21.7973 29.2493 19.6875 31.86V33.75H39.375C40.8668 33.75 42.2976 33.1574 43.3525 32.1025C44.4074 31.0476 45 29.6168 45 28.125V5.625C45 4.13316 44.4074 2.70242 43.3525 1.64752C42.2976 0.592632 40.8668 0 39.375 0H5.625ZM9.84375 11.25C9.47079 11.25 9.1131 11.1018 8.84938 10.8381C8.58566 10.5744 8.4375 10.2167 8.4375 9.84375C8.4375 9.47079 8.58566 9.1131 8.84938 8.84938C9.1131 8.58566 9.47079 8.4375 9.84375 8.4375H35.1562C35.5292 8.4375 35.8869 8.58566 36.1506 8.84938C36.4143 9.1131 36.5625 9.47079 36.5625 9.84375C36.5625 10.2167 36.4143 10.5744 36.1506 10.8381C35.8869 11.1018 35.5292 11.25 35.1562 11.25H9.84375ZM25.3125 21.0938C25.3125 20.7208 25.4607 20.3631 25.7244 20.0994C25.9881 19.8357 26.3458 19.6875 26.7188 19.6875H35.1562C35.5292 19.6875 35.8869 19.8357 36.1506 20.0994C36.4143 20.3631 36.5625 20.7208 36.5625 21.0938C36.5625 21.4667 36.4143 21.8244 36.1506 22.0881C35.8869 22.3518 35.5292 22.5 35.1562 22.5H26.7188C26.3458 22.5 25.9881 22.3518 25.7244 22.0881C25.4607 21.8244 25.3125 21.4667 25.3125 21.0938ZM9.84375 33.75C7.23303 33.75 4.72923 32.7129 2.88317 30.8668C1.03711 29.0208 0 26.517 0 23.9062C0 21.2955 1.03711 18.7917 2.88317 16.9457C4.72923 15.0996 7.23303 14.0625 9.84375 14.0625C12.4545 14.0625 14.9583 15.0996 16.8043 16.9457C18.6504 18.7917 19.6875 21.2955 19.6875 23.9062C19.6875 26.517 18.6504 29.0208 16.8043 30.8668C14.9583 32.7129 12.4545 33.75 9.84375 33.75ZM2.8125 34.4306C4.89388 35.8209 7.34076 36.5628 9.84375 36.5625C12.4453 36.5625 14.8641 35.775 16.875 34.4306V42.1875C16.875 42.4487 16.8023 42.7047 16.665 42.9268C16.5277 43.149 16.3312 43.3285 16.0976 43.4453C15.8641 43.5621 15.6026 43.6115 15.3425 43.5881C15.0824 43.5646 14.8339 43.4692 14.625 43.3125L10.6875 40.3594C10.4441 40.1768 10.148 40.0781 9.84375 40.0781C9.53948 40.0781 9.24342 40.1768 9 40.3594L5.0625 43.3125C4.85357 43.4692 4.60514 43.5646 4.34504 43.5881C4.08494 43.6115 3.82344 43.5621 3.58986 43.4453C3.35627 43.3285 3.15982 43.149 3.02252 42.9268C2.88522 42.7047 2.8125 42.4487 2.8125 42.1875V34.4306Z"
          fill={
            isActive && openMobileSideBar
              ? "#2b5972"
              : openMobileSideBar
              ? "#ffffff"
              : isActive
              ? "#2b5972"
              : "#84909A"
          }
        />
      </svg>
    );
  };
  const LogbookIcon = ({ isActive, openMobileSideBar }) => (
    <svg
      width="14"
      height="35"
      viewBox="0 0 41 45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg "
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3846 33.3785C40.3818 33.4891 40.371 33.5994 40.3523 33.7085C40.401 33.959 40.3936 34.2172 40.3308 34.4645C40.268 34.7119 40.1512 34.9423 39.9889 35.1392C39.8266 35.3362 39.6227 35.4948 39.3919 35.6037C39.1611 35.7126 38.9091 35.7691 38.6538 35.7692H6.34615C5.96734 35.7692 5.59224 35.8438 5.24226 35.9888C4.89228 36.1338 4.57428 36.3463 4.30642 36.6141C4.03856 36.882 3.82608 37.2 3.68112 37.55C3.53615 37.8999 3.46154 38.275 3.46154 38.6538C3.46154 39.0327 3.53615 39.4078 3.68112 39.7577C3.82608 40.1077 4.03856 40.4257 4.30642 40.6936C4.57428 40.9614 4.89228 41.1739 5.24226 41.3189C5.59224 41.4638 5.96734 41.5385 6.34615 41.5385H38.6538C39.1129 41.5385 39.5531 41.7208 39.8777 42.0454C40.2023 42.37 40.3846 42.8102 40.3846 43.2692C40.3846 43.7283 40.2023 44.1685 39.8777 44.4931C39.5531 44.8177 39.1129 45 38.6538 45H6.34615C4.66305 45 3.04888 44.3314 1.85874 43.1413C0.66861 41.9511 0 40.337 0 38.6538V6.34615C0 4.66305 0.66861 3.04888 1.85874 1.85875C3.04888 0.668611 4.66305 0 6.34615 0H37.2692C38.9908 0 40.3846 1.39385 40.3846 3.11538V33.3785ZM13.2692 9.23077C12.8102 9.23077 12.37 9.41312 12.0454 9.7377C11.7208 10.0623 11.5385 10.5025 11.5385 10.9615C11.5385 11.4206 11.7208 11.8608 12.0454 12.1854C12.37 12.51 12.8102 12.6923 13.2692 12.6923H27.1154C27.5744 12.6923 28.0146 12.51 28.3392 12.1854C28.6638 11.8608 28.8462 11.4206 28.8462 10.9615C28.8462 10.5025 28.6638 10.0623 28.3392 9.7377C28.0146 9.41312 27.5744 9.23077 27.1154 9.23077H13.2692Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
    </svg>
  );
  const PerformanceAppraisalIcon = ({ isActive, openMobileSideBar }) => (
    <svg
      width="16"
      height="35"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg "
    >
      <path
        d="M1 32.5364C1 31.3241 1.98279 30.3413 3.19512 30.3413H7.58537C8.7977 30.3413 9.78049 31.3241 9.78049 32.5364V41.3169H1V32.5364Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
      <path
        d="M13.0742 24.8536C13.0742 23.6412 14.057 22.6584 15.2693 22.6584H19.6596C20.8719 22.6584 21.8547 23.6412 21.8547 24.8536V41.317H13.0742V24.8536Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
      <path
        d="M25.1445 19.3658C25.1445 18.1534 26.1273 17.1707 27.3397 17.1707H31.7299C32.9422 17.1707 33.925 18.1534 33.925 19.3658V41.317H25.1445V19.3658Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
      <path
        d="M37.2188 12.7803C37.2188 11.568 38.2015 10.5852 39.4139 10.5852H43.8041C45.0164 10.5852 45.9992 11.568 45.9992 12.7803V41.3169H37.2188V12.7803Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
      <path
        d="M0.666643 24.4177C0.425887 24.6018 0.379964 24.9463 0.564072 25.187C0.74818 25.4278 1.0926 25.4737 1.33336 25.2896L0.666643 24.4177ZM10.3293 17.7195L10.2216 17.1814C10.1396 17.1978 10.0624 17.2328 9.99591 17.2836L10.3293 17.7195ZM18.561 16.0732L18.6686 16.6113C18.7822 16.5886 18.8857 16.5305 18.9642 16.4454L18.561 16.0732ZM25.1463 8.93902V8.39024C24.9932 8.39024 24.847 8.45425 24.7431 8.5668L25.1463 8.93902ZM32.8293 8.93902V9.4878C32.9748 9.4878 33.1144 9.42999 33.2173 9.32707L32.8293 8.93902ZM37.7683 4V3.45122C37.6227 3.45122 37.4832 3.50904 37.3802 3.61195L37.7683 4ZM46 4L40.5122 0.831614V7.16839L46 4ZM1.33336 25.2896L10.6626 18.1554L9.99591 17.2836L0.666643 24.4177L1.33336 25.2896ZM10.4369 18.2576L18.6686 16.6113L18.4534 15.535L10.2216 17.1814L10.4369 18.2576ZM18.9642 16.4454L25.5496 9.31125L24.7431 8.5668L18.1577 15.7009L18.9642 16.4454ZM25.1463 9.4878H32.8293V8.39024H25.1463V9.4878ZM33.2173 9.32707L38.1563 4.38805L37.3802 3.61195L32.4412 8.55098L33.2173 9.32707ZM37.7683 4.54878H41.061V3.45122H37.7683V4.54878Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
    </svg>
  );
  const AbstractIcon = ({ isActive, openMobileSideBar }) => (
    <svg
      width="15"
      height="28"
      viewBox="0 0 36 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg "
    >
      <path
        d="M20.25 15.75V3.375L32.625 15.75M4.5 0C2.0025 0 0 2.0025 0 4.5V40.5C0 41.6935 0.474106 42.8381 1.31802 43.682C2.16193 44.5259 3.30653 45 4.5 45H31.5C32.6935 45 33.8381 44.5259 34.682 43.682C35.5259 42.8381 36 41.6935 36 40.5V13.5L22.5 0H4.5Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
    </svg>
  );

  const MarksheetIcon = ({ isActive, openMobileSideBar }) => (
    <svg
      width="16"
      height="28"
      viewBox="0 0 38 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg "
    >
      <path
        d="M0 5V40C0 41.3261 0.44484 42.5979 1.23666 43.5355C2.02848 44.4732 3.10242 45 4.22222 45H33.7778C34.8976 45 35.9715 44.4732 36.7633 43.5355C37.5552 42.5979 38 41.3261 38 40V5C38 3.67392 37.5552 2.40215 36.7633 1.46447C35.9715 0.526784 34.8976 0 33.7778 0H4.22222C3.10242 0 2.02848 0.526784 1.23666 1.46447C0.44484 2.40215 0 3.67392 0 5ZM14.7778 10H31.6667V15H14.7778V10ZM14.7778 20H31.6667V25H14.7778V20ZM14.7778 30H31.6667V35H14.7778V30ZM6.33333 10H10.5556V15H6.33333V10ZM6.33333 20H10.5556V25H6.33333V20ZM6.33333 30H10.5556V35H6.33333V30Z"
        fill={
          isActive && openMobileSideBar
            ? "#2b5972"
            : openMobileSideBar
            ? "#ffffff"
            : isActive
            ? "#2b5972"
            : "#84909A"
        }
      />
    </svg>
  );

  return (
    <>
      {openMobileSideBar ? (
        <div className=" w-full h-lvh text-white sticky left-0 flex relative">
          <div className="w-5/6  bg-primary-title h-full pt-8">
            {role === "User" ? (
              <Link to="/">
                <div
                  className={` ${
                    isSidebarCollapsed ? "mt-10 " : ""
                  }flex justify-center`}
                >
                  <img
                    src="/assets/images/Logo.png"
                    alt="Logo"
                    className={`h-16 ${
                      isSidebarCollapsed ? "hidden " : "block"
                    }`}
                  />
                </div>
              </Link>
            ) : (
              <Link to="/dashboard">
                <div
                  className={` ${
                    isSidebarCollapsed ? "mt-10 " : ""
                  }flex justify-center`}
                >
                  <img
                    src="/assets/images/Logo.png"
                    alt="Logo"
                    className={`h-16 ${
                      isSidebarCollapsed ? "hidden " : "block"
                    }`}
                  />
                </div>
              </Link>
            )}
            {admin && (
              <>
                <div className="flex mt-3  bg-primary-title rounded-md p-2 w-full">
                  <Link
                    to={
                      role === "PartnerCenter"
                        ? "/admin/students"
                        : "/admin/students"
                    }
                  >
                    <div className="flex bg-primary-title rounded-md gap-3 items-center p-3 border-[1px] border-white  ">
                      <div className="rounded-full bg-white text-primary-title flex justify-center items-center">
                        <KeyboardArrowLeftRoundedIcon />
                      </div>
                      {!isSidebarCollapsed && (
                        <span className="text-white font-poppins text-sm">
                          Back to admin dash
                        </span>
                      )}
                    </div>
                  </Link>
                </div>
                <div className="border-[1px] border-gray-400 mt-2 w-full"></div>
              </>
            )}

            <div className="mt-2">
              {role === "Administrator" ? (
                <Link to="/dashboard">
                  <SidebarButton
                    icon={DashboardIcon}
                    title="Dashboard"
                    isActive={activeButton === "Dashboard"}
                    onClick={() => {
                      setActiveButton("Dashboard");
                      dispatch(setOpenMobileSidebar());
                    }}
                  />
                </Link>
              ) : (
                <Link to="/">
                  <SidebarButton
                    icon={DashboardIcon}
                    title="Dashboard"
                    isActive={activeButton === "Dashboard"}
                    onClick={() => {
                      setActiveButton("Dashboard");
                      dispatch(setOpenMobileSidebar());
                    }}
                  />
                </Link>
              )}

              <Link to="/profile">
                <SidebarButton
                  icon={ProfileIcon}
                  title="Profile"
                  isActive={activeButton === "Profile"}
                  onClick={() => {
                    setActiveButton("Profile");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/certificates">
                <SidebarButton
                  icon={CertificateIcon}
                  title="Certificates"
                  isActive={activeButton === "Certificates"}
                  onClick={() => {
                    setActiveButton("Certificates");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/logbook">
                <SidebarButton
                  icon={LogbookIcon}
                  title="Log Books"
                  isActive={activeButton === "Log Books"}
                  onClick={() => {
                    setActiveButton("Log Books");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/performanceappraisal">
                <SidebarButton
                  icon={PerformanceAppraisalIcon}
                  title="Performance Appraisal"
                  isActive={activeButton === "Performance Appraisal"}
                  onClick={() => {
                    setActiveButton("Performance Appraisal");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/abstract">
                <SidebarButton
                  icon={AbstractIcon}
                  title="Abstract"
                  isActive={activeButton === "Abstract"}
                  onClick={() => {
                    setActiveButton("Abstract");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/markingguideline">
                <SidebarButton
                  icon={MarksheetIcon}
                  title="Marking Guideline"
                  isActive={activeButton === "Marking Guideline"}
                  onClick={() => {
                    setActiveButton("Marking Guideline");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
            </div>
            <div
              className=" absolute bg-[#9A3C3C] bottom-28 sm:bottom-3 w-3/4 left-5 justify-center"
              onClick={handleLogout}
            >
              <button
                type="button"
                className="bg-[#9A3C3C] flex justify-center  p-4 px-4 text-[14px] text-white rounded-[5px] font-poppins w-full"
              >
                Logout
              </button>
              {/* <Button title="Logout" className="rounded-md bg-[#9A3C3C] w-full" /> */}
            </div>
          </div>
          <div
            className="w-1/6 bg-neutral-700 opacity-45"
            onClick={() => dispatch(setOpenMobileSidebar())}
          ></div>
        </div>
      ) : (
        <div
          className={` relative bg-primary-background h-screen sticky top-0 transition-all duration-300 md:${
            isSidebarCollapsed ? "w-20 py-5 p-3" : "md:w-64 lg:w-72 p-5"
          }`}
        >
          {role === "User" ? (
            <Link to="/">
              <div
                className={`${isSidebarCollapsed ? "" : ""} flex justify-start`}
              >
                <img
                  src={
                    !isSidebarCollapsed
                      ? `${process.env.PUBLIC_URL}/assets/images/Logo.png`
                      : `${process.env.PUBLIC_URL}/assets/images/short-logo.png`
                  }
                  alt="Logo"
                  className={` ${isSidebarCollapsed ? "h-8" : "h-20"}`}
                />
              </div>
            </Link>
          ) : (
            <Link to="/dashboard">
              <div
                className={`${
                  isSidebarCollapsed ? "" : ""
                } flex justify-center`}
              >
                <img
                  src={
                    !isSidebarCollapsed
                      ? `/assets/images/Logo.png`
                      : `/assets/images/short-logo.png`
                  }
                  alt="Logo"
                  className={`${isSidebarCollapsed ? "h-8" : "h-20"}`}
                />
              </div>
            </Link>
          )}

          {admin && (
            <>
              <div className="flex mt-3 bg-primary-title rounded-md p-2 w-full">
                <Link
                  to={
                    role === "PartnerCenter"
                      ? "/admin/students"
                      : "/admin/students"
                  }
                >
                  <div className="flex bg-primary-title rounded-md gap-3 items-center">
                    <div className="rounded-full bg-white text-primary-title flex justify-center items-center">
                      <KeyboardArrowLeftRoundedIcon />
                    </div>
                    {!isSidebarCollapsed && (
                      <span className="text-white font-poppins text-sm">
                        Back to admin dash
                      </span>
                    )}
                  </div>
                </Link>
              </div>
              <div className="border-[1px] border-gray-400 mt-2 w-full"></div>
            </>
          )}

          {/* Sidebar Content Wrapper */}
          <div className="flex flex-col mt-10 md:h-[calc(100%-120px)] overflow-hidden">
            <div className="flex-1 overflow-y-auto">
              {/* Scrollable Sidebar Buttons */}
              {role === "User" ? (
                <Link to="/">
                  <SidebarButton
                    icon={DashboardIcon}
                    title="Dashboard"
                    isActive={activeButton === "Dashboard"}
                    onClick={() => setActiveButton("Dashboard")}
                  />
                </Link>
              ) : (
                <Link to="/dashboard">
                  <SidebarButton
                    icon={DashboardIcon}
                    title="Dashboard"
                    isActive={activeButton === "Dashboard"}
                    onClick={() => setActiveButton("Dashboard")}
                  />
                </Link>
              )}
              <Link to="/profile">
                <SidebarButton
                  icon={ProfileIcon}
                  title="Profile"
                  isActive={activeButton === "Profile"}
                  onClick={() => setActiveButton("Profile")}
                />
              </Link>
              <Link to="/certificates">
                <SidebarButton
                  icon={CertificateIcon}
                  title="Certificates"
                  isActive={activeButton === "Certificates"}
                  onClick={() => setActiveButton("Certificates")}
                />
              </Link>
              <Link to="/logbook">
                <SidebarButton
                  icon={LogbookIcon}
                  title="Log Books"
                  isActive={activeButton === "Log Books"}
                  onClick={() => setActiveButton("Log Books")}
                />
              </Link>
              <Link to="/performanceappraisal">
                <SidebarButton
                  icon={PerformanceAppraisalIcon}
                  title="Performance Appraisal"
                  isActive={activeButton === "Performance Appraisal"}
                  onClick={() => setActiveButton("Performance Appraisal")}
                />
              </Link>
              <Link to="/abstract">
                <SidebarButton
                  icon={AbstractIcon}
                  title="Abstract"
                  isActive={activeButton === "Abstract"}
                  onClick={() => setActiveButton("Abstract")}
                />
              </Link>
              <Link to="/markingguideline">
                <SidebarButton
                  icon={MarksheetIcon}
                  title="Marking Guideline"
                  isActive={activeButton === "Marking Guideline"}
                  onClick={() => setActiveButton("Marking Guideline")}
                />
              </Link>
            </div>
            {/* Absolute Positioned Logout Button */}
            <div
              className={`  mb-2 mt-2 w-full ${
                role === "Administrator" ? "mb-7" : ""
              } `}
              onClick={handleLogout}
            >
              <button
                className={`bg-[#9A3C3C] w-full px-4 p-2 text-[14px] text-white rounded-[5px] font-poppins flex justify-center items-center ${
                  isSidebarCollapsed ? "p-4" : "p-3"
                }`}
                type="button"
              >
                {!isSidebarCollapsed && <span>Logout</span>}
                <i
                  className={`fa-solid fa-arrow-right-from-bracket ${
                    isSidebarCollapsed ? "" : "ml-12"
                  }`}
                ></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
